import { Component, Inject, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { CurrentUserService } from '@common/current-user/current-user.service';
import { DowntimeNotificationComponent } from '@common/downtime-notification';
import { ProductTranslations } from '@common/util/products';
import { UserNotificationService } from '@common/util/user-notification.service';
import { defaultIfEmpty, filter, first, mergeMap } from 'rxjs';
import { SidebarService } from './sidebar.service';

@Component({
    selector: 'assets-rt-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    providers: [SidebarService],
    standalone: false
})
export class SidebarComponent implements OnInit {
  public version = '1.001';
  public year = new Date().getFullYear();
  public hasNotifications$ = this.userNotificationSrv.notification$;

  constructor(
    public srv: SidebarService,
    public currentUserSrv: CurrentUserService,
    private domSanitizer: DomSanitizer,
    private matIconRegistry: MatIconRegistry,
    private userNotificationSrv: UserNotificationService,
    private bottomSheet: MatBottomSheet,
    @Inject(ProductTranslations) protected products: ProductTranslations,
  ) {
    this.matIconRegistry.addSvgIcon(
      'wheelchair',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/wheelchair.svg')
    );
  }

  ngOnInit(): void {
    this.userNotificationSrv.notification$
      .pipe(
        mergeMap((data) =>
          this.currentUserSrv.getPreference(`ca_notification_${data.id}_read`).pipe(
            first(),
            filter((read) => !read),
            mergeMap(() => this.openDowntimeNotification(data))
          )
        )
      )
      .subscribe(
        (data) =>
          data && this.currentUserSrv.save(`ca_notification_${data.id}_read`, true)
      );
  }

  openDowntimeNotification(userNotification) {
    return this.bottomSheet
      .open(DowntimeNotificationComponent, {
        disableClose: true,
        hasBackdrop: false,
        data: { userNotification },
      })
      .afterDismissed();
  }

  openNotification() {
    this.userNotificationSrv.notification$
      .pipe(defaultIfEmpty(null))
      .subscribe((data) => this.openDowntimeNotification(data));
  }
}
